import { Typography } from "@mui/material";
import BoldSpanText from "components/shared/BoldSpanText";
import PageSection from "components/shared/PageSection";

/**
 * * About section of the Homepage
 * @returns {React.ReactElement} About
 */
export default function About() {
  return (
    <PageSection
      id="about-section"
      backgroundSx={{
        backgroundColor: (theme) => theme.palette.secondary.main,
      }}
    >
      <Typography variant="h2">Think big. Act boldly.</Typography>
      <Typography variant="h6">
        At Astrin, we know that to win the fight against cancer, we must think
        big and act boldly. It is with this pioneering spirit that we developed
        Astrin's breakthrough
        <BoldSpanText>
          {" "}
          AI-Empowered 3D Holographic Imaging Platform{" "}
        </BoldSpanText>
        for early cancer detection and treatment management.
      </Typography>
    </PageSection>
  );
}
